import { axios } from '@Root/API'

export const edit = (contactId, data) => {
  return axios.put('student-detail', { ...data, id: contactId })
}
